import { gql } from "@apollo/client";

export const SAVE_INSURANCE_SIMULATION = gql`
  mutation saveInsuranceSimulation($insuranceSimulation: InsuranceSimulationInput!) {
    saveInsuranceSimulation(insuranceSimulation: $insuranceSimulation) {
      correlationId
    }
  }
`;

export const SAVE_GENERAL_INSURANCE_DATA = gql`
  mutation saveGeneralInsuranceData($input: GeneralInsuranceDataInput!) {
    saveGeneralInsuranceData(input: $input) {
      correlationId
    }
  }
`;

export const UPDATE_RTI_OPTION = gql`
  mutation updateRtiOption($insuranceSimulationId: Int!, $rtiOption: Boolean!, $offerId: Int!, $offerSiteId: Int!) {
    updateRtiOption(
      insuranceSimulationId: $insuranceSimulationId
      rtiOption: $rtiOption
      offerId: $offerId
      offerSiteId: $offerSiteId
    )
  }
`;

export const SELECT_INSURANCE_QUOTATION = gql`
  mutation selectInsuranceQuotation($insuranceSimulationId: Int!, $insuranceQuotationId: Int!) {
    selectInsuranceQuotation(
      insuranceSimulationId: $insuranceSimulationId
      insuranceQuotationId: $insuranceQuotationId
    ) {
      correlationId
    }
  }
`;

export const SELECT_DEFAULT_SUBCATEGORY = gql`
  mutation selectDefaultSubcategory(
    $offerId: Int!
    $offerSiteId: Int!
    $insuranceSimulationId: Int!
    $documentDetailId: Int!
    $categoryCode: String!
  ) {
    selectDefaultSubcategory(
      offerId: $offerId
      offerSiteId: $offerSiteId
      insuranceSimulationId: $insuranceSimulationId
      documentDetailId: $documentDetailId
      categoryCode: $categoryCode
    ) {
      correlationId
    }
  }
`;

export const UPDATE_CASCO_QUOTATION = gql`
  mutation updateCascoQuotation($cascoQuotation: CascoQuotationInput!) {
    updateCascoQuotation(cascoQuotation: $cascoQuotation) {
      correlationId
    }
  }
`;

export const SELECT_RCA_QUOTATION = gql`
  mutation selectRcaQuotation($insuranceSimulationId: Int!, $insuranceQuotationId: Int!, $quotationDetailId: Int!) {
    selectRcaQuotation(
      insuranceSimulationId: $insuranceSimulationId
      insuranceQuotationId: $insuranceQuotationId
      quotationDetailId: $quotationDetailId
    ) {
      correlationId
    }
  }
`;

export const UPDATE_RTI_PERIODICITY = gql`
  mutation updateRtiPeriodicity($insuranceSimulationId: Int!, $paymentPeriodicity: Int!) {
    updateRtiPeriodicity(insuranceSimulationId: $insuranceSimulationId, paymentPeriodicity: $paymentPeriodicity)
  }
`;

export const REQUEST_INSURANCE_NEGOTIATION = gql`
  mutation requestInsuranceNegotiation(
    $insuranceSimulationId: Int!
    $insuranceTypeCode: String!
    $negotiationReason: String
    $negotiationQuotationsIds: [Int!]!
  ) {
    requestInsuranceNegotiation(
      insuranceSimulationId: $insuranceSimulationId
      insuranceTypeCode: $insuranceTypeCode
      negotiationReason: $negotiationReason
      negotiationQuotationsIds: $negotiationQuotationsIds
    ) {
      correlationId
    }
  }
`;

export const CHECK_REQUIRED_DOCUMENTS_EXISTENCE = gql`
  mutation checkRequiredDocumentsExistence(
    $offerId: Int!
    $offerSiteId: Int!
    $documentDetailId: Int!
    $documentDetailSiteId: Int!
    $insuranceSimulationId: Int!
  ) {
    checkRequiredDocumentsExistence(
      offerId: $offerId
      offerSiteId: $offerSiteId
      documentDetailId: $documentDetailId
      documentDetailSiteId: $documentDetailSiteId
      insuranceSimulationId: $insuranceSimulationId
    ) {
      correlationId
    }
  }
`;
